import calendly from "./calendly";

const styles = {
  global: {
    html: {
      scrollBehavior: "smooth",
    },
    body: {
      scrollBehavior: "smooth",
      minHeight: "100vh",
      bgColor: "#FFFFFF",
      color: "rgb(13,48,80)",
    },
    ...calendly,
  },
};

export default styles;
